export default __webpack_public_path__ + "static/media/serguei2.26ab43a1.jpg";